import WorkerReview from 'src/pages/WorkerReview';
import { BrowserRouter, Navigate, useRoutes } from 'react-router-dom';
import { getLoginPath, getPrincipal, isReviewMode } from 'src/utils/auth';
import Login from 'src/pages/login';
import Main from 'src/pages/Main';
import Error from 'src/pages/Error';

const AppRoutes = () => useRoutes([
  { path: '/user-mode/:coId', element: <WorkerReview /> },
  { path: '/login', element: <Login /> },
  { path: '/main', element: (getPrincipal()?.type === 'USER' || (isReviewMode() && !!sessionStorage.getItem('review_user'))) ? <Main /> : <Navigate to={getLoginPath()} replace /> },
  { path: '/error', element: <Error /> },
  { path: '*', element: <Login /> },
]);
const Router = () => (
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <AppRoutes />
  </BrowserRouter>
);
export default Router;
